import React from 'react';
import '@styles/LoadingScreen.css';
import loadingGif from '@assets/loading.gif'; 

const LoadingScreen = ({ opacity = 0.7, text = "Loading..." }) => {
  return (
    <div className="loading-overlay" style={{ backgroundColor: `rgba(0, 0, 0, ${opacity})` }}>
      <div className="loading-content">
        {/* <div className="spinning-barbell"></div> */}
        <img 
          src={loadingGif} 
          alt="Loading animation" 
          className="loading-gif"
        />
        <p className="loading-text">{text}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;